export default {
  props: ["history_data"]
};